/**
 * Formats currency values with proper thousands separators and currency symbol
 * @param {number} amount - The amount to format
 * @param {string} currency - The currency symbol to use
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount, currency = "€") => {
	return `${amount.toFixed(2).replace(".", ",")} ${currency}`;
};
